import { logEvent } from './analyticsUtils';

const mapWidgetAnalytics = () => {

  const ANALYTICS_EVENTS = {

    AboutLocationHuntUnitClick: 'about_location_hunt_unit_click',
    AboutLocationLayerClick: 'about_location_layer_click',
    AboutLocationCoordinatesCopied: 'about_location_coordinates_copied',
    TooltipShown: 'tooltip_shown',

    SelectFeatures: 'select_features',

    SelectToCollection: 'select_to_collection',
    SelectToDelete: 'select_to_delete',
    SelectToCancel: 'select_to_cancel',

    MeasureTool: 'measure_tool',

    TwoDToggled: 'toggled_two_d',
    ThreeDToggled: 'toggled_three_d',

    BasemapToggled: 'toggle_basemap',

    CoordinateSystemUpdated: 'updated_coordinate_system',

    MapSearchUsed: 'used_map_search',

    FeatureInfoViewed: 'viewed_feature_info',
    LocationInfoViewed: 'viewed_location_info',

    TerrainAnalysisEnabled: 'terrain_analysis_enabled',
    TerrainAnalysisDisabled: 'terrain_analysis_disabled',

    HistoricalImageryLoaded: 'historical_imagery_loaded',

    MapsMainUpgradeCta: 'clicked_maps_main_upgrade_cta',
    MapsNavUpgradeCta: 'clicked_maps_nav_upgrade_cta',
  };

  const logSelectFeatures = (featuresList) => {
    logEvent(ANALYTICS_EVENTS.SelectFeatures, {
      featuresCount: featuresList.length,
    });
  };

  const logSelectToCollection = (selectedFeatures) => {
    logEvent(ANALYTICS_EVENTS.SelectToCollection, {
      featureCount: selectedFeatures.length,
    });
  };

  const logSelectToDelete = (selectedFeatures) => {
    logEvent(ANALYTICS_EVENTS.SelectToDelete, {
      featureCount: selectedFeatures.length,
    });
  };

  const logSelectToCancel = (selectedFeatures) => {
    logEvent(ANALYTICS_EVENTS.SelectToCancel, {
      featureCount: selectedFeatures.length,
    });
  };

  const logMeasureTool = () => {
    logEvent(ANALYTICS_EVENTS.MeasureTool);
  };

  const logTwoDToggled = () => {
    logEvent(ANALYTICS_EVENTS.TwoDToggled);
  };

  const logThreeDToggled = () => {
    logEvent(ANALYTICS_EVENTS.ThreeDToggled);
  };

  const logBasemapToggled = (basemap) => {
    logEvent(ANALYTICS_EVENTS.BasemapToggled,{
      basemap,
    });
  };

  const logCoordinateSystemUpdated = (coordsType) => {
    logEvent(ANALYTICS_EVENTS.CoordinateSystemUpdated,{
      coordinate_system: coordsType,
    });
  };

  const logMapSearchUsed = (searchTerm) => {
    logEvent(ANALYTICS_EVENTS.MapSearchUsed,{
      search_term: searchTerm,
    });
  };

  const logFeatureInfoViewed = (position, numFeatures) => {
    logEvent(ANALYTICS_EVENTS.FeatureInfoViewed,{
      position,
      info_count_ugc: numFeatures,
    });
  };

  const logLocationInfoViewed = (position, numLayers) => {
    logEvent(ANALYTICS_EVENTS.FeatureInfoViewed,{
      position,
      info_count_layers: numLayers,
    });
  };

  const logTerrainAnalysisEnabled = () => {
    logEvent(ANALYTICS_EVENTS.TerrainAnalysisEnabled);
  };

  const logTerrainAnalysisDisabled = () => {
    logEvent(ANALYTICS_EVENTS.TerrainAnalysisDisabled);
  };

  const logHistoricalImageryLoaded = () => {
    logEvent(ANALYTICS_EVENTS.HistoricalImageryLoaded);
  };

  const logAboutLocationHuntUnitClick = (unitNumber, layerName, stateName) => {
    logEvent(ANALYTICS_EVENTS.AboutLocationHuntUnitClick, {
      unit_number: unitNumber,
      layer_name: layerName,
      state_name: stateName,
    });
  };

  const logAboutLocationLayerClick = (layerName) => {
    logEvent(ANALYTICS_EVENTS.AboutLocationLayerClick, {
      layer_name: layerName,
    });
  };

  const logAboutLocationCoordinatesCopied = () => {
    logEvent(ANALYTICS_EVENTS.AboutLocationCoordinatesCopied);
  };

  const logTooltipShown = (heading) => {
    logEvent(ANALYTICS_EVENTS.TooltipShown, { heading });
  };

  const logMapsMainUpgradeCta = () => {
    logEvent(ANALYTICS_EVENTS.MapsMainUpgradeCta);
  };

  const logMapsNavUpgradeCta = (eventProps = {}) => {
    logEvent(ANALYTICS_EVENTS.MapsNavUpgradeCta, eventProps);
  };

  return {
    logSelectFeatures,

    logSelectToCollection,
    logSelectToDelete,
    logSelectToCancel,

    logMeasureTool,

    logTwoDToggled,
    logThreeDToggled,

    logBasemapToggled,

    logCoordinateSystemUpdated,

    logMapSearchUsed,

    logFeatureInfoViewed,
    logLocationInfoViewed,

    logTerrainAnalysisEnabled,
    logTerrainAnalysisDisabled,

    logHistoricalImageryLoaded,

    logAboutLocationHuntUnitClick,
    logAboutLocationLayerClick,
    logAboutLocationCoordinatesCopied,
    logTooltipShown,

    logMapsMainUpgradeCta,

    logMapsNavUpgradeCta,
  };
};

export default mapWidgetAnalytics();